import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssVarsProvider } from '@mui/joy/styles';
import { CssBaseline } from '@mui/joy';
import { AuthProvider } from '@contexts/AuthContext';
import { ProtectedRoute } from '@components/auth/ProtectedRoute';
import { MainLayout } from '@layouts/MainLayout';
import { ROUTES } from '@constants/routes';

// Import pages
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { Notifications } from './pages/Notifications';
import { SecurityAudit } from './pages/SecurityAudit';
import { Settings } from './pages/Settings';
import { VulnerabilityScan } from './pages/VulnerabilityScan';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { ContactSupport } from './pages/ContactSupport';
import { Compliance } from './pages/Compliance';
import { Security } from './pages/Security';
import { ITSolutions } from './pages/ITSolutions';
import { SoftwareDevelopment } from './pages/SoftwareDevelopment';
import { LandingPage } from './pages/LandingPage';
import { AboutUs } from './pages/AboutUs';
import { Careers } from './pages/Careers';
import { Blog } from './pages/Blog';
import { BlogPostDetail } from './pages/BlogPostDetail';
import { DeleteData } from './pages/DeleteData';

import './App.css';

function App() {
  return (
    <CssVarsProvider>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
              <Route path={ROUTES.TERMS_OF_SERVICE} element={<TermsOfService />} />
              <Route path={ROUTES.CONTACT_SUPPORT} element={<ContactSupport />} />
              <Route path={ROUTES.COMPLIANCE} element={<Compliance />} />
              <Route path={ROUTES.SECURITY} element={<Security />} />
              <Route path={ROUTES.IT_SOLUTIONS} element={<ITSolutions />} />
              <Route path={ROUTES.SOFTWARE_DEVELOPMENT} element={<SoftwareDevelopment />} />
              <Route path={ROUTES.ABOUT} element={<AboutUs />} />
              <Route path={ROUTES.CAREERS} element={<Careers />} />
              <Route path={ROUTES.BLOG} element={<Blog />} />
              <Route path={ROUTES.BLOG_DETAIL} element={<BlogPostDetail />} />
              <Route path={ROUTES.DELETE_DATA} element={<DeleteData />} />

              {/* Auth Routes */}
              <Route path={ROUTES.LOGIN} element={<Login />} />

              {/* Protected Dashboard Routes */}
              <Route path={ROUTES.DASHBOARD} element={
                <ProtectedRoute>
                  <MainLayout>
                    <Dashboard />
                  </MainLayout>
                </ProtectedRoute>
              } />

              <Route path={ROUTES.SECURITY_AUDIT} element={
                <ProtectedRoute>
                  <MainLayout>
                    <SecurityAudit />
                  </MainLayout>
                </ProtectedRoute>
              } />

              <Route path={ROUTES.VULNERABILITY_SCAN} element={
                <ProtectedRoute>
                  <MainLayout>
                    <VulnerabilityScan />
                  </MainLayout>
                </ProtectedRoute>
              } />

              <Route path={ROUTES.NOTIFICATIONS} element={
                <ProtectedRoute>
                  <MainLayout>
                    <Notifications />
                  </MainLayout>
                </ProtectedRoute>
              } />

              <Route path={ROUTES.SETTINGS} element={
                <ProtectedRoute>
                  <MainLayout>
                    <Settings />
                  </MainLayout>
                </ProtectedRoute>
              } />

              {/* Catch-all route for 404 */}
              <Route
                path="*"
                element={
                  <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center">
                      <h1 className="text-4xl font-bold text-secondary-900 mb-4">
                        Page Not Found
                      </h1>
                      <p className="text-lg text-secondary-600">
                        The page you're looking for doesn't exist.
                      </p>
                    </div>
                  </div>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </CssVarsProvider>
  );
}

export default App;